"use client";

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import Loader from '@/components/Loader';

interface PodcastRedirectProps {
  redirectUrl: string;
}

export default function PodcastRedirect({ redirectUrl }: PodcastRedirectProps) {
  const router = useRouter();

  useEffect(() => {
    router.replace(redirectUrl);
  }, [router, redirectUrl]);

  return <Loader />;
}

